<template>
  <div class="c-select-product-card">
    <input
      :id="lineItem.id"
      v-model="checkedCheckbox"
      :name="lineItem.title"
      type="checkbox"
      class="c-select-product-card__checkbox"
      :disabled="!canEngrave"
    >
    <label
      :for="lineItem.id"
      class="c-select-product-card__label l-grid l-grid--3-col-fixed"
      :class="!canEngrave ? 'c-select-product-card__label--disabled' : ''"
    >
      <div class="c-select-product-card__image-wrapper l-grid__item--justify-end">
        <img
          class="c-select-product-card__image"
          :src="lineItem.variant.featuredMedia.thumbnailSrc"
          :alt="lineItem.variant.featuredMedia.altText || lineItem.title"
        >
      </div>
      <div class="c-select-product-card__title-wrapper l-grid__item--span-2-fixed">
        <h4 class="t-heading-6">
          {{ lineItem.title }}
        </h4>
        <p
          v-if="size"
          class="t-heading-8--light t-heading-8"
        >
          Size {{ size }}
        </p>
      </div>
    </label>
  </div>
</template>
<script>
export default {
  name: "SelectProductCard",
  props:{
    id: {
      type:String,
      default:''
    },
    lineItem: {
      type: Object,
      default: ()=>{}
    },
  },
  data() {
    return {
      checkedCheckbox: false,
    }
  },
  computed: {
    size() {
      let theSize = this.lineItem.variant.selectedOptions.find((obj=>obj.name == "Size"));
      if(theSize){
        return theSize.value;
      }
      else return false;
    },
    canEngrave() {
      if(this.lineItem.metafieldsMap &&
        !this.lineItem.metafieldsMap.engraving ||
          this.lineItem.metafieldsMap &&
          this.lineItem.metafieldsMap.engraving &&
          this.lineItem.customAttributes &&
          this.lineItem.customAttributes.find((obj)=>obj.key == 'location')) {
        return false;
      }
      else {
        return true;
      }

    }
  },
  watch: {
    checkedCheckbox() {
      this.$emit("checkboxChanged", {product:this.lineItem, variant:this.lineItem.variant, upsell:true, open:true})
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-product-card {
  padding-top: rem(20px);
  padding-bottom: rem(20px);
  &__label {
    position:relative;
    &:before {
      content: '';
      position: absolute;
      display: inline-block;
      margin-right: rem(10px);
      width: 25px;
      height: 25px;
      @include themify($themes) {
        border:  3px solid themed('foreground', 'x-light-text');
      }
      border-radius: 2px;
    }
    &--disabled {
      opacity: .5;
    }
  }
  &__checkbox {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);

    &:checked + .c-select-product-card__label:before {
      content: ' ✓';
      font-size:18px;
      padding:rem(4px);
      padding-top:0px;
      @include themify($themes) {
        color: themed('foreground', 'accent-text');
      }
    }
    /* These are the checkbox focous colors not part of site style */
    &:focus + .c-select-product-card__label:before {
      outline: #5d9dd5 solid 1px;
      box-shadow: 0 0 rem(8px) #5e9ed6;
    }
    &:focus:checked + .c-select-product-card__label:before {
      outline: #5d9dd5 solid 1px;
      box-shadow: 0 0 rem(8px) #5e9ed6;
    }
  }
  &__image-wrapper {
    display: inline-block;
  }
  &__image {
    posistion: absolute;
    right: 0;
    width: rem(75px);
    padding: rem(7px) rem(10px) rem(7px) rem(7px);
    @include themify($themes) {
      background-color: themed('foreground', 'input-border');
    }

  }
  &__title-wrapper {
    display: inline-block;
  }
}
</style>